import { gql, useMutation } from "@apollo/client";

const EDIT_PLAYER_MUTATION = gql`
    mutation EditPlayer($input: PlayerRosterInput!) {
        editPlayer(input: $input) {
            roster {
                id
                shirtNumber
                position {
                    key
                    name
                }
            }
        }
    }
`;

export default function EditPlayerMutation() {
    return useMutation(EDIT_PLAYER_MUTATION);
}

